import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { DemandPartner } from '../domain/demand-partner.model';
import { ActivityStatus } from '../domain/activity-status.model';

@Injectable()
export class AdStatsDemandPartnersService {

  constructor(private httpClient: HttpClient) {
  }

  demandPartners(): Observable<DemandPartner[]> {
    return this.httpClient.get<DemandPartner[]>(`${environment.serviceUrl}/ad-stats/demand-partners`);
  }

  demandPartnersListAll(statuses: ActivityStatus[]): Observable<DemandPartner[]> {
    return this.httpClient.post<DemandPartner[]>(`${environment.serviceUrl}/ad-stats/demand-partners/list-all`, statuses);
  }

  demandPartnerUpdate(demandPartner: DemandPartner): Observable<null> {
    return this.httpClient.put<null>(`${environment.serviceUrl}/ad-stats/demand-partners/${demandPartner.id}`, demandPartner);
  }

}

